export default __webpack_public_path__ + "graphics/quote.02abc604.svg";